export default "__VITE_ASSET__DUgngPtq__"